export default __webpack_public_path__ + "static/media/About-img.4f573868.jpg";